import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { Small, MediumUp } from 'components/MediaQuery';
import { medium, largeUp } from 'constants/mediaQueries';

import { IMAGE_HEIGHTS } from './constants';

const PageSectionImage = ({ image }) => {
  const landscapeImage = get(image, 'imageLandscape');
  const portraitImage = get(image, 'imagePortrait');

  return (
    <>
      <Small>
        <div
          className="PageSectionImage__background-image Lazy"
          role="img"
          aria-label={get(portraitImage, 'title')}
          data-bg={get(portraitImage, ['file', 'cloudinaryUrl'])}
        />
      </Small>
      <MediumUp>
        <div
          className="PageSectionImage__background-image Lazy"
          role="img"
          aria-label={get(landscapeImage, 'title')}
          data-bg={get(landscapeImage, ['file', 'cloudinaryUrl'])}
        />
      </MediumUp>
      <style jsx>
        {`
          .PageSectionImage__background-image {
            width: 100%;
            height: ${IMAGE_HEIGHTS.SMALL}px;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
          }

          @media ${medium} {
            .PageSectionImage__background-image {
              height: ${IMAGE_HEIGHTS.MEDIUM}px;
            }
          }

          @media ${largeUp} {
            .PageSectionImage__background-image {
              height: ${IMAGE_HEIGHTS.LARGE_UP}px;
            }
          }
        `}
      </style>
    </>
  );
};
const imagePropType = PropTypes.shape({
  file: PropTypes.shape({
    cloudinaryUrl: PropTypes.string.isRequired,
  }).isRequired,
  title: PropTypes.string,
});

PageSectionImage.propTypes = {
  image: PropTypes.shape({
    imageLandscape: imagePropType.isRequired,
    imagePortrait: imagePropType.isRequired,
  }).isRequired,
};

export default PageSectionImage;
